<template>
  <div class="tertiary fullWidth mt-3 mainTitle">
    <div class="maximize">
      <h1 class="display-2 font-weight-bold titleText">
        {{ title }}
      </h1>
    </div>

    <div class="primary py-4 white--text font-weight-bold px-5 breadcrumb">
      <RouterLink :to="{ name: 'Home' }">
        Főoldal
      </RouterLink>

      <RouterLink
        v-if="parentRoute"
        :to="{ name: 'Services', params: { slug: parentRoute.slug } }"
      >
        - {{ parentRoute.title }}
      </RouterLink>

      - {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThePageHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    parentRoute: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.mainTitle {
  position: relative;
  padding: 64px 46px 64px 46px;
  color: #212121;
}

@media (max-width: 959px) {
  .mainTitle {
    padding: 64px 10px 64px 10px;
  }
}

.breadcrumb {
  border-top-left-radius: 35px;
  border-bottom-left-radius: 35px;
  position: absolute;
  right: 0;
  left: 50%;
  bottom: -34px;
}

.titleText {
  line-height: 1 !important;
}

@media (max-width: 959px) {
  .titleText {
    font-size: 32px !important;
  }

  .breadcrumb {
    left: 5%;
    padding: 20px 24px 20px 24px !important;
  }
}
</style>
